var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Expose, Type } from 'class-transformer';
import { DunningRunStatus } from '../enums/dunning-run-status.enum.js';
/**
 * One row in the DunningRun history list. Mirrors the persisted run summary —
 * date, executor, status, and the success / total counts that drive the
 * "X / Y erfolgreich" badge. Clicking a row falls through to the existing
 * status endpoint for the per-row table, so this DTO intentionally does not
 * carry item details.
 */
export class DunningRunHistoryRowDto {
    id;
    status;
    /** ISO timestamp — the moment the aggregate was created (button click). */
    createdAt;
    /** ISO timestamp — null while still PENDING. */
    startedAt;
    /** ISO timestamp — null until COMPLETED / CANCELED / FAILED. */
    completedAt;
    triggeredByUserId;
    executorFirstName;
    executorLastName;
    totalCount;
    successCount;
}
__decorate([
    Expose(),
    __metadata("design:type", String)
], DunningRunHistoryRowDto.prototype, "id", void 0);
__decorate([
    Expose(),
    __metadata("design:type", String)
], DunningRunHistoryRowDto.prototype, "status", void 0);
__decorate([
    Expose(),
    __metadata("design:type", String)
], DunningRunHistoryRowDto.prototype, "createdAt", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Object)
], DunningRunHistoryRowDto.prototype, "startedAt", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Object)
], DunningRunHistoryRowDto.prototype, "completedAt", void 0);
__decorate([
    Expose(),
    __metadata("design:type", String)
], DunningRunHistoryRowDto.prototype, "triggeredByUserId", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Object)
], DunningRunHistoryRowDto.prototype, "executorFirstName", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Object)
], DunningRunHistoryRowDto.prototype, "executorLastName", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Number)
], DunningRunHistoryRowDto.prototype, "totalCount", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Number)
], DunningRunHistoryRowDto.prototype, "successCount", void 0);
/**
 * Response of `GET /v1/offices/:officeId/dunningRun/history` — a paginated list
 * of past (and currently in-flight) Mahnläufe scoped to the caller's allowed
 * OfficeLocations. In-flight runs come first, followed by terminal runs
 * sorted by `createdAt` descending. `total` is the unpaginated row count for
 * "Mehr laden" pagination.
 */
export class DunningRunHistoryResponseDto {
    rows;
    total;
}
__decorate([
    Expose(),
    Type(() => DunningRunHistoryRowDto),
    __metadata("design:type", Array)
], DunningRunHistoryResponseDto.prototype, "rows", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Number)
], DunningRunHistoryResponseDto.prototype, "total", void 0);
//# sourceMappingURL=dunning-run-history.response.dto.js.map